<template>
    <div class="footer">
        <img src="@/assets/Logos.png">
    </div>
</template>

<script>
    export default {
        name: "Footer",
    }
</script>

<style lang="scss" scoped>

    .footer {
        padding: 0 5% 7% 5%;

            @media screen and (max-width: 768px) {
                padding: 7% 2% 7% 2%;
            }
    }

    img {
         height: auto;
         width: 100%;
    }

</style>